import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private data = signal<any>(null);
  private dbName = 'myDatabase';
  private storeName = 'myStore';
  private initDb() {
    const request = indexedDB.open(this.dbName, 1);

    request.onupgradeneeded = (event: any) => {
      const db = event.target.result;
      db.createObjectStore(this.storeName, { keyPath: 'id', autoIncrement: true });
    };
  }

  constructor() {
    this.initDb();

   }
  //  setData(data: string) {
  //   console.log('abcddd',data)
  //   this.data.set(data);
  // }

  // getData(){
  //   return this.data();  }

  


    
  
    setData(data: any) {
      const request = indexedDB.open(this.dbName);
      request.onsuccess = (event: any) => {
        const db = event.target.result;
        const transaction = db.transaction(this.storeName, 'readwrite');
        const store = transaction.objectStore(this.storeName);
        store.put({ id: 1, data }); // Adjust the logic as needed
      };
    }
  
    getData(callback: (data: any) => void) {
      const request = indexedDB.open(this.dbName);
      request.onsuccess = (event: any) => {
        const db = event.target.result;
        const transaction = db.transaction(this.storeName, 'readonly');
        const store = transaction.objectStore(this.storeName);
        const dataRequest = store.get(1); // Adjust the logic as needed
  
        dataRequest.onsuccess = () => {
          callback(dataRequest.result ? dataRequest.result.data : null);
        };
      };
    }
  }

